import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import './Hero.css';

const Hero = () => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Building Scalable Digital Solutions for <span className="black-text">Modern Businesses</span>
          </h1>
          <p className="hero-subtitle">
            We transform ideas into powerful digital products. From startups to enterprises, 
            we deliver cutting-edge web, mobile, and cloud solutions.
          </p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">
              Get Started to Build Your Idea <ArrowRight size={20} />
            </Link>
            <Link to="/services" className="btn btn-outline">
              Explore Services
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;